import React from 'react'

const Underline = () => <div className="line-x line-x--100"></div>

export { Underline as default }
